import { render, staticRenderFns } from "./AccrualsEstimatesViewSwitcher.vue?vue&type=template&id=3094c393&scoped=true"
import script from "./AccrualsEstimatesViewSwitcher.vue?vue&type=script&lang=js"
export * from "./AccrualsEstimatesViewSwitcher.vue?vue&type=script&lang=js"
import style0 from "./AccrualsEstimatesViewSwitcher.vue?vue&type=style&index=0&id=3094c393&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3094c393",
  null
  
)

export default component.exports